<div class="action-edit">
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    class="action-item">
    <div
      class="item-color"
      [ngStyle]="{ 'background-color': destinationColorCode }">
      &nbsp;
    </div>
    <div
      class="item-name"
      [ngClass]="{ 'is-empty': !destinationName }">
      {{ destinationName }}
    </div>
  </div>
  <div class="separator"></div>
  <div class="body">
    <div class="mb-2">
      <label>{{ 'MANAGEMENT.WORKFLOW.ACTION-LABEL' | translate }}</label>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <div>
          <input
            #input
            class="input is-small input-set"
            type="text"
            [(ngModel)]="label" />
        </div>
        @if (hasLanguages$ | async) {
          <button
            title="{{ 'MANAGEMENT.DATASETS.TRANSLATIONS' | translate }}"
            class="button is-small is-ghost"
            (click)="translateClick()">
            <i class="icon icon-globe"></i>
          </button>
        }
      </div>
    </div>

    <div class="mb-2">
      <div>
        <label class="checkbox">
          <div
            fxLayout="row"
            fxLayoutAlign="start center">
            <input
              type="checkbox"
              [value]="'primaryAction'"
              [checked]="isPrimaryAction"
              (change)="primaryActionChecked($event)"
              class="mr-3 checkbox-size" />
            <div class="checkbox-text">{{ 'MANAGEMENT.WORKFLOW.PRIMARY-ACTION' | translate }}</div>
          </div>
        </label>
      </div>
    </div>

    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="mt-4">
      <div></div>
      <div
        fxLayout="row"
        fxLayoutAlign="end">
        <div class="mr-1">
          <button
            class="button is-small is-secondary"
            (click)="cancelClick()">
            {{ 'DASHBOARDS.BUTTONS.CANCEL' | translate }}
          </button>
        </div>
        <div>
          <button
            class="button is-small is-primary"
            (click)="saveClick()">
            {{ 'DASHBOARDS.BUTTONS.SAVE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

@if (!!_action && showTranslations) {
  <topo-action-label-translations
    [actions]="[_action]"
    (updateTranslations)="updateTranslations($event)"
  (cancel)="cancelTranslations($event)"></topo-action-label-translations>
}
